import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .hefesto-progress__label {
    display: none;
  }
`;

export const ModalOutContainer = styled.div`
  .hefesto-modal__overlay {
    z-index: 99999;
  }

  .hefesto-modal__footer {
    display: none;
  }

  .hefesto-modal__body {
    margin-bottom: 0;
  }

  .hefesto-modal__header {
    margin-bottom: 12px;
    h3 {
      font-size: 24px;
      line-height: 32px;
      color: #495961;
      font-weight: 600;
      margin: 0;
    }
  }
  .hefesto-modal__body {
    color: #414e55;
  }
`;

export const Subtitle = styled.span`
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
